// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs--breadcrumbs--zsJy7","breadcrumb":"Breadcrumbs--breadcrumb--pDYvt"};